
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { singularityStore } from "@/store/store";
import { SingularityUIState } from "@/store/modules/singularity";
import Icon from "@/components/UI/Icon.vue";

type BackStateType =
  | SingularityUIState["singularityLeftPanel"]
  | (() => void)
  | null;

@Component({
  components: {
    Icon
  }
})
export default class PanelHeader extends Vue {
  @Prop({ default: "Title" }) parentTitle!: string;

  @Prop() childTitle!: string | null;

  @Prop() backState!: BackStateType;

  @Prop({ default: false }) isGlobal!: boolean;

  goBackToPanelState() {
    if (typeof this.backState === "function") {
      this.backState();
    } else if (this.backState) {
      singularityStore.setSingularityLeftPanel(this.backState);
    }
  }
}
